var map = {
	"./about-us.png": "8013",
	"./allies.png": "8b85",
	"./app.png": "ea62",
	"./benefits.png": "38b7",
	"./bets-providers.png": "727f",
	"./bets.png": "ffef",
	"./betsss.png": "c5e2",
	"./cellphone.png": "8858",
	"./chart.png": "ca3e",
	"./computer.png": "6333",
	"./dealer.png": "1e36",
	"./favicon.ico": "6e9c",
	"./icons/Archivo.zip": "6762",
	"./icons/Seguros_11.5x.png": "f1f2",
	"./icons/app-gallery.png": "a18c",
	"./icons/app-store.png": "dbca",
	"./icons/approved.png": "aed0",
	"./icons/approvedBold.png": "5639",
	"./icons/arrow.png": "1894",
	"./icons/bold.png": "d975",
	"./icons/certificates.png": "06f7",
	"./icons/check.png": "e209",
	"./icons/computer.png": "63e0",
	"./icons/fb.png": "acad",
	"./icons/fintech.png": "3408",
	"./icons/gambling.png": "b880",
	"./icons/google-play.png": "9dd1",
	"./icons/ig.png": "af95",
	"./icons/insurance.png": "5a8d",
	"./icons/line-mark.png": "e5db",
	"./icons/logo-watermark.png": "d33c",
	"./icons/logo.png": "e0dd",
	"./icons/logoPay.png": "b470",
	"./icons/logoW.png": "dbc1",
	"./icons/pays.png": "8117",
	"./icons/pins.png": "e0c5",
	"./icons/social-networks.png": "9fbe",
	"./icons/topup.png": "84f0",
	"./icons/wallets.png": "31bd",
	"./icons/warning.png": "a4c5",
	"./icons/whatsapp.png": "1545",
	"./initial.png": "a08e",
	"./initialll.png": "df1b",
	"./insurance-providers.png": "f35a",
	"./insurance.png": "606a",
	"./insuranceee.png": "0b16",
	"./multiproduct.png": "9d99",
	"./payment/american.png": "89e2",
	"./payment/mastercard.png": "64b9",
	"./payment/pse.png": "4d33",
	"./qrBancolombia/1.png": "ae98",
	"./qrBancolombia/2.png": "0f39",
	"./qrBancolombia/3.png": "8f1e",
	"./qrBancolombia/4.png": "b0b5",
	"./qrBancolombia/5.png": "1ec7",
	"./qrBancolombia/6.png": "8c3a",
	"./qrBancolombia/7.png": "3e9c",
	"./qrBancolombia/8.png": "6480",
	"./qrBancolombia/9.png": "6c07",
	"./qrBancolombia/Bancolombia.png": "3104",
	"./qrBancolombia/Cellphone.png": "0fd5",
	"./qrBancolombia/Nequi.png": "93e2",
	"./qrBancolombia/Noticias.jpg": "bdf1",
	"./qrBancolombia/Refacil.png": "f3fd",
	"./qrBancolombia/Tutoriales.jpg": "b722",
	"./qrBancolombia/Tutorials.png": "09de",
	"./qrBancolombia/background.png": "4894",
	"./quotation-marks.png": "9ab7",
	"./shape.png": "71d3",
	"./style.scss": "73ec",
	"./styles/index.css": "c898",
	"./topup-providers.png": "5b92",
	"./topups.png": "a45e",
	"./topupsss.png": "072b",
	"./usability.png": "caec"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";